export default {"src":"/_next/static/media/pulse_logo_rgb_black.1bc20caf.svg","height":66,"width":275,"blurWidth":0,"blurHeight":0};